export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {}
};



// WEBPACK FOOTER //
// ./src/mixins/globalDialog.js